import { NextLink } from './NextLink';

export type { TypeNextLinkProps } from './types';
export default NextLink;
